import React from 'react';
import DiagramUtils from '../../utils/DiagramUtils';
import DiagramUI from "../DiagramUI";
import Model from "./EllipseModel";

export default class UI extends DiagramUI {

    state = {};

    constructor(props, context) {
        super(props, context);
    }

    render() {

        const style = this.props.model.toStyle();

        return (
            <div className={"diagram-ui " + (this.props.className || "")} style={style}  >
                {this.props.model.text}
            </div>
        );
    }
}

const type = new Model().getType();
DiagramUtils.register(type, {
    model: Model,
    name: type,
    alias: "椭圆",
    catalog: "其他",
    svg: "#anticon-end_node",
    uiGetter: (model) => <UI model={model} />
});